// extracted by mini-css-extract-plugin
module.exports = {"lightGreyBorder":"#c4c4c4","list":"OperationList_list__19usa","listHeader":"OperationList_listHeader__1nEUh","listContent":"OperationList_listContent__3jZWB"};